import * as Yup from 'yup';

import YupUtil from '@utils/YupUtil';

export const ServicesSchema = Yup.object().shape({
    title: YupUtil.getStringTrimmedScheme('title', 'Title', true, 5, 50),
    serviceId: YupUtil.getStringDropdownScheme('serviceId', 'Service', true),
    notes: YupUtil.getStringTrimmedScheme('notes', 'Notes', false, 10, 500),
});
